import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=f2b0179a&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b0179a')) {
      api.createRecord('f2b0179a', component.options)
    } else {
      api.reload('f2b0179a', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=f2b0179a&", function () {
      api.rerender('f2b0179a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GebcKOZ9BxQo/JS/CurrentYear.vue"
export default component.exports